import { FiBriefcase, FiStar, FiZap, HiOutlineDocument, HiOutlineSparkles } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons.js';

const CommandBarRowIcon = ({ row }) => {
  const sizeMap = {
    default: 14,
    workflows: 16
  };

  const iconMap = {
    default: row?.meta?.appIcon || utilityAppIcons[row?.meta?.appSlug] || FiStar,
    workflows: FiZap,
    jobs: FiBriefcase,
    companies: FiBriefcase,
    ai: HiOutlineSparkles,
    pages: HiOutlineDocument
  };

  const classMap = {
    ai: 'ai-icon'
  };

  const isCustomColor = row?.type === 'ai' || !row?.type;
  const size = sizeMap[row.type] || sizeMap.default;
  const Icon = iconMap[row.type] || iconMap.default;
  const className = `${classMap[row.type] || ''} ${isCustomColor ? 'custom-color' : ''}`;

  return <IconV2 size={size} className={className} icon={Icon} />;
};

export default CommandBarRowIcon;
